import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import '@/assets/leaflet/assets/helpers/draw/sector.css';

import {createApp} from 'vue';

import {keycloakAPI} from '@/assets/keycloak';

import App from './App.vue';
import {getRouter, initRouter} from './router';
import {install as VueMonacoEditorPlugin} from '@guolao/vue-monaco-editor';

keycloakAPI.init().then(() => {
  initRouter();
  createApp(App)
    .use(VueMonacoEditorPlugin, {
      paths: {
        vs: 'https://cdn.jsdelivr.net/npm/monaco-editor@0.43.0/min/vs',
      },
    })
    .use(getRouter())
    .mount('#app');
});
